import React from 'react'
import { motion } from 'framer-motion';
import { className } from 'aplazame-design-system';
import Container from '../../componentsV2/Container';
import Calculator from '../Calculator';
import style from './style.module.scss';
import colorStyle from 'aplazame-design-system/src/scss/color.module.scss';

const stagger = {
    hidden: {},
    visible: {
        transition: { staggerChildren: 0.25, delayChildren: 0.8 },
    },
};

const fadeInUp = {
    hidden: {
        opacity: 0,
        y: 40,
    },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            type: 'tween',
            ease: 'easeIn',
        },
    },
};


function WrapperCalculator(props) {
    const hasColorScheme = props.colorScheme !== 'None';
    return (
        <motion.section
            variants={stagger}
            initial="hidden"
            whileInView="visible"
            viewport={{ amount: 'some', once: true }}
            {...className(
                hasColorScheme
                    ? colorStyle[`bg-${props.colorScheme}`]
                    : style.bgcolor
            )}
        >
            <Container>
                <motion.div
                    variants={fadeInUp}
                    className={style.wrapper}>
                    <Calculator />
                </motion.div>
            </Container>
        </motion.section>
    )
}

export default WrapperCalculator
